// @ts-nocheck
import blogCategoryReducer, {
    BlogCategoryActions,
} from "@store/Framework/Store/Starter/Pages/BlogCategory/BlogCategoryReducer";
import productListReducer, {
    ProductListActions,
} from "@store/Framework/Store/Starter/Pages/ProductList/ProductListReducer";
import { combineReducers } from "redux";

const pagesReducer = combineReducers({
    blogCategory: blogCategoryReducer,
    productList: productListReducer,
});

export type PagesActions = BlogCategoryActions | ProductListActions;

export default pagesReducer;
